export enum DefaultFeatures {
  Users = "users",
  API = "api",
  PrioritySupport = "priority-support",
  LinkedAccounts = "links",
  BlogPosts = "blog-posts",
  Credits = "credits",
  PrivateGenerations = "private-generations",
  Alert = "alerts",
  CompanyCount = "company-count",
}
